import React, { useEffect } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useLocalStorage from 'react-localstorage-hook';

export const ReferralClosedTab = () => {
  const [, setShouldPublish] = useLocalStorage('shouldPublishReferralClosed', false);

  useEffect(() => {
    setShouldPublish(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePublish = () => setShouldPublish(true);

  return (
    <Accordion id="referralClosedTab">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>referralClosed</Typography>
        <Button
          id="publish-referral-closed"
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handlePublish();
          }}
          variant="contained"
        >
          Publish
        </Button>
      </AccordionSummary>
      <AccordionDetails />
    </Accordion>
  );
};
